import { render, staticRenderFns } from "./BaseChartCard.vue?vue&type=template&id=68fb835d&"
import script from "./BaseChartCard.vue?vue&type=script&lang=js&"
export * from "./BaseChartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports